<template>
  <main id="content">
    <section class="pt-4 pb-4">
      <b-container style="max-width: 950px">
        <b-row>
          <b-col md="4">
            <SettingsNav />
          </b-col>
          <b-col md="8">
            <div class="card card-body">
              <div
                v-if="loading1"
                class="p-5 d-flex justify-content-center text-muted w-100"
              >
                <font-awesome-icon icon="sync" size="2x" spin />
              </div>
              <div v-else-if="subscription">
                <h2 class="h4 mb-3" style="text-transform: capitalize">
                  <b-button
                    to="/settings/subscriptions"
                    variant="secondary"
                    class="mr-2 mt-minus no-margin"
                  >
                    <font-awesome-icon icon="arrow-left" />
                  </b-button>
                  <span v-if="subscription.plan">
                    <span
                      style="text-transform: none"
                      v-if="subscription.metadata.friendly_name"
                      >{{ subscription.metadata.friendly_name + " - " }}
                    </span>
                    {{ subscription.plan.nickname }}
                  </span>
                  <b-badge :class="'badge ' + subscription.status">
                    {{ subscription.status }}
                  </b-badge>
                  <b-badge
                    v-if="subscription.cancel_at_period_end"
                    :class="'badge non_renewing'"
                    >Non Renewing</b-badge
                  >
                  <b-badge v-if="isFreeSubscription" :class="'badge future'"
                    >Free</b-badge
                  >
                </h2>
                <div>
                  <div v-if="subscription.metadata.company_name">
                    <strong>Company Name:</strong>
                    {{ subscription.metadata.company_name }}
                  </div>
                  <div v-if="subscription.metadata.billing_address">
                    <strong>Billing Address:</strong>
                    {{ subscription.metadata.billing_address }}
                  </div>
                  <div>
                    <strong>Price:</strong>
                    {{ subscription.plan.currency.toUpperCase() }}
                    {{ subscription.plan.amount / 100 }} / user /
                    {{ subscription.plan.interval }}
                  </div>
                  <div>
                    <strong>Number of users:</strong>
                    {{ subscription.quantity }}
                  </div>
                  <div>
                    <strong>Billing period:</strong>
                    <span v-if="subscription.plan">{{
                      subscription.plan.interval_count
                    }}</span>
                    <span v-if="subscription.plan">{{
                      subscription.plan.interval
                    }}</span>
                  </div>
                  <div>
                    <strong>Created on:</strong>
                    {{
                      new Date(subscription.created * 1000).toLocaleDateString(
                        "en-us",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        }
                      )
                    }}
                  </div>
                  <div v-if="subscription.cancel_at_period_end">
                    <strong>Ending on:</strong>
                    {{
                      new Date(
                        subscription.current_period_end * 1000
                      ).toLocaleDateString("en-us", {
                        month: "short",
                        day: "numeric",
                        year: "numeric"
                      })
                    }}
                  </div>
                  <div
                    v-if="
                      !subscription.cancel_at_period_end &&
                        subscription.status !== 'canceled'
                    "
                  >
                    <strong>Next billing on:</strong>
                    {{
                      new Date(
                        subscription.current_period_end * 1000
                      ).toLocaleDateString("en-us", {
                        month: "short",
                        day: "numeric",
                        year: "numeric"
                      })
                    }}
                  </div>
                  <!-- <div><strong>Due invoices:</strong> {{subscription.due_invoices_count}}</div> -->
                  <div v-if="subscription.status === 'trialing'">
                    <div>
                      <strong>Trial started on:</strong>
                      {{
                        new Date(
                          subscription.trial_start * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })
                      }}
                    </div>
                    <div>
                      <strong>Trial ends on:</strong>
                      {{
                        new Date(
                          subscription.trial_end * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })
                      }}
                    </div>
                  </div>
                  <div
                    v-if="
                      subscription.cancel_at_period_end ||
                        subscription.status === 'canceled'
                    "
                    class="text-danger"
                  >
                    <div>
                      <strong>Cancelled on:</strong>
                      {{
                        new Date(
                          subscription.canceled_at * 1000
                        ).toLocaleDateString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric"
                        })
                      }}
                    </div>
                  </div>
                </div>
                <div v-if="myRole == 'admin'">
                  <div
                    class="mt-3"
                    v-if="
                      !subscription.cancel_at_period_end &&
                        subscription.status !== 'canceled'
                    "
                  >
                    <b-button
                      id="btnCancelSubscriptionButton"
                      v-b-modal.deleteModal
                      variant="danger"
                      class="icon-left m-1"
                    >
                      <font-awesome-icon icon="trash" />Cancel subscription
                    </b-button>
                    <span v-if="!showEditForm">
                      <b-button
                        variant="primary"
                        class="icon-left m-1"
                        @click="showEditForm = !showEditForm"
                        :disabled="isSendingEditForm"
                        :pressed="showEditForm"
                      >
                        <font-awesome-icon icon="edit" />
                        Edit subscription
                      </b-button>
                    </span>
                    <span v-else>
                      <b-button
                        variant="danger"
                        class="icon-left m-1"
                        @click="showEditForm = !showEditForm"
                        :disabled="isSendingEditForm"
                        :pressed="showEditForm"
                      >
                        Close
                      </b-button>
                    </span>
                    <b-modal
                      id="deleteModal"
                      title="Cancel subscription"
                      @ok="deleteSubscription(subscription.id)"
                      ok-variant="danger"
                      ok-title="Yes, cancel my subscription"
                      cancel-title="No, don't cancel"
                    >
                      <p>
                        Are you sure you want to cancel your subscription? You
                        or your assignees will not be able to read or write any
                        data after cancellation.
                      </p>
                      <p>
                        Advance charges, if any, will be refunded as credits.
                      </p>
                    </b-modal>
                    <template v-if="showEditForm">
                      <transition name="fade">
                        <b-form class="mt-2" @submit.prevent>
                          <hr />
                          <b-form-group label="Friendly Name">
                            <b-form-input
                              id="txtUpdateSubscriptionFriendlyNameField"
                              trim
                              v-model="updateSubscription.name"
                              :state="
                                $v.updateSubscription.name.$dirty
                                  ? !$v.updateSubscription.name.$error
                                  : null
                              "
                              aria-describedby="new-sub-name-input-live-help new-sub-name-input-live-feedback"
                              @blur="$v.updateSubscription.name.$touch()"
                              placeholder="Enter a friendly name for this subscription"
                              type="text"
                            />

                            <b-form-invalid-feedback
                              id="new-sub-name-input-live-feedback"
                            >
                              <p>
                                <span
                                  v-if="!$v.updateSubscription.name.maxLength"
                                  >Name can be at most
                                  {{
                                    $v.updateSubscription.name.$params.maxLength
                                      .max
                                  }}
                                  characters. <br />
                                </span>
                                <span
                                  v-if="!$v.updateSubscription.name.required"
                                >
                                  This is a required field.
                                </span>
                              </p>
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <span v-if="!isFreeSubscription">
                            <b-form-group label="Company Name">
                              <b-form-input
                                id="txtUpdateSubscriptionCompanyNameField"
                                trim
                                v-model="updateSubscription.c_name"
                                :state="
                                  $v.updateSubscription.c_name.$dirty
                                    ? !$v.updateSubscription.c_name.$error
                                    : null
                                "
                                aria-describedby="new-com-name-input-live-help new-com-name-input-live-feedback"
                                @blur="$v.updateSubscription.c_name.$touch()"
                                placeholder="Enter a Company name for this subscription"
                                type="text"
                              />

                              <b-form-invalid-feedback
                                id="new-com-name-input-live-feedback"
                              >
                                <p>
                                  <span
                                    v-if="
                                      !$v.updateSubscription.c_name.maxLength
                                    "
                                    >Name can be at most
                                    {{
                                      $v.updateSubscription.c_name.$params
                                        .maxLength.max
                                    }}
                                    characters. <br />
                                  </span>
                                  <span
                                    v-if="
                                      !$v.updateSubscription.c_name.required
                                    "
                                  >
                                    This is a required field.
                                  </span>
                                </p>
                              </b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group label="Billing Address">
                              <b-form-textarea
                                id="txtUpdateSubscriptionBillingAddressField"
                                trim
                                v-model="updateSubscription.b_address"
                                :state="
                                  $v.updateSubscription.b_address.$dirty
                                    ? !$v.updateSubscription.b_address.$error
                                    : null
                                "
                                aria-describedby="new-bill-address-input-live-help new-bill-address-input-live-feedback"
                                @blur="$v.updateSubscription.b_address.$touch()"
                                placeholder="Enter a billing address"
                                rows="3"
                                max-rows="6"
                              >
                              </b-form-textarea>
                              <b-form-invalid-feedback
                                id="new-bill-address-input-live-feedback"
                              >
                                <p>
                                  <span
                                    v-if="
                                      !$v.updateSubscription.b_address.maxLength
                                    "
                                    >Name can be at most
                                    {{
                                      $v.updateSubscription.b_address.$params
                                        .maxLength.max
                                    }}
                                    characters. <br />
                                  </span>
                                  <span
                                    v-if="
                                      !$v.updateSubscription.b_address.required
                                    "
                                  >
                                    This is a required field.
                                  </span>
                                </p>
                              </b-form-invalid-feedback>
                            </b-form-group>
                            <b-input-group>
                              <b-input-group-prepend>
                                <b-btn
                                  variant="danger"
                                  @click="updateSubscription.newSeats--"
                                  :disabled="
                                    check_number(
                                      updateSubscription.newSeats,
                                      sUsers
                                    )
                                  "
                                >
                                  <i class="fa fa-minus-circle"></i>
                                </b-btn>
                              </b-input-group-prepend>
                              <b-form-input
                                id="txtUpdateSubscriptionAddUsersField"
                                type="number"
                                number
                                min="1"
                                placeholder="Enter number of new users to add to this subscription"
                                v-model="updateSubscription.newSeats"
                                :state="
                                  $v.updateSubscription.newSeats.$dirty
                                    ? !$v.updateSubscription.newSeats.$error
                                    : null
                                "
                                @blur="$v.updateSubscription.newSeats.$touch()"
                                aria-describedby="new-sub-new-seats-input-live-feedback new-sub-new-seats-input-live-help"
                              />
                              <b-input-group-append>
                                <b-btn
                                  variant="success"
                                  @click="updateSubscription.newSeats++"
                                >
                                  <i class="fa fa-plus-circle"></i>
                                </b-btn>
                              </b-input-group-append>
                            </b-input-group>
                            <b-form-text id="new-sub-new-seats-input-live-help"
                              >Note: This is an optional field</b-form-text
                            >
                            <b-form-invalid-feedback
                              id="new-sub-new-seats-input-live-feedback"
                            >
                              Please enter an integer greater than 0.
                            </b-form-invalid-feedback>
                            <b-alert
                              :show="
                                updateSubscription.newSeats > 0 &&
                                  !$v.updateSubscription.newSeats.$invalid
                              "
                              v-if="
                                updateSubscription.newSeats >
                                  subscription.quantity
                              "
                              variant="info"
                            >
                              <p>
                                Your monthly charge will be
                                <strong v-if="subscription.plan">
                                  {{ updateSubscription.newSeats }}
                                  X
                                  {{ subscription.plan.amount / 100 }}
                                  {{ subscription.plan.currency.toUpperCase() }}
                                  =
                                  {{
                                    (subscription.plan.amount / 100) *
                                      updateSubscription.newSeats
                                  }}
                                  {{ subscription.plan.currency.toUpperCase() }}
                                </strong>
                                per month.
                              </p>
                            </b-alert>
                            <b-alert
                              :show="
                                updateSubscription.newSeats > 0 &&
                                  !$v.updateSubscription.newSeats.$invalid
                              "
                              v-if="
                                updateSubscription.newSeats <
                                  subscription.quantity
                              "
                              variant="danger"
                            >
                              <p>
                                Your monthly charge will be
                                <strong v-if="subscription.plan">
                                  {{ updateSubscription.newSeats }}
                                  X
                                  {{ subscription.plan.amount / 100 }}
                                  {{ subscription.plan.currency.toUpperCase() }}
                                  =
                                  {{
                                    (subscription.plan.amount / 100) *
                                      updateSubscription.newSeats
                                  }}
                                  {{ subscription.plan.currency.toUpperCase() }}
                                </strong>
                                per month.
                              </p>
                            </b-alert>
                          </span>
                          <b-button
                            id="btnSubscriptionSubmitUpdate"
                            type="submit"
                            variant="primary"
                            @click="submitEditFormAction()"
                            :disabled="
                              $v.updateSubscription.$invalid ||
                                isSendingEditForm
                            "
                          >
                            <span v-if="!isSendingEditForm">
                              Submit
                              <font-awesome-icon icon="arrow-right" />
                            </span>
                            <span v-else>
                              Updating &nbsp;
                              <font-awesome-icon icon="sync" spin />
                            </span>
                          </b-button>
                        </b-form>
                      </transition>
                    </template>
                  </div>
                  <div class="mt-3" v-else>
                    <b-button
                      @click="reactivateSubscription(subscription.id)"
                      variant="primary"
                      class="m-1"
                    >
                      Reactivate
                      <font-awesome-icon icon="arrow-right" />
                    </b-button>
                  </div>
                </div>
              </div>
              <div v-else>Error: Subscription not found</div>
            </div>
            <div class="card card-body">
              <h2 class="h4 mb-3">Users</h2>
              <p>
                These users have access to read/write mapping data in this
                subscription.
              </p>
              <div
                v-if="loading2"
                class="p-5 d-flex justify-content-center text-muted w-100"
              >
                <font-awesome-icon icon="sync" size="2x" spin />
              </div>
              <div v-else-if="sUsers.length > 0">
                <div
                  v-for="(user, i) in sUsers"
                  :key="user.id"
                  class="card card-body"
                >
                  <div v-if="!user.details">
                    <b-row>
                      <b-col cols="2" class="text-right d-none d-md-block">
                        <img
                          alt
                          :src="constants.profile.default_user_image"
                          class="avatar"
                        />
                      </b-col>
                      <b-col>
                        <div>
                          <span>
                            <font-awesome-icon icon="sync" spin />&nbsp; Loading
                            name...
                          </span>
                        </div>
                        <div class="text-muted">
                          <span>
                            <font-awesome-icon icon="sync" spin />&nbsp; Loading
                            email...
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else>
                    <b-row>
                      <b-col cols="2" class="text-right d-none d-md-block">
                        <img
                          alt
                          :src="
                            user.details.photoURL ||
                              constants.profile.default_user_image
                          "
                          class="avatar"
                        />
                      </b-col>
                      <b-col>
                        <div>
                          <span>{{ user.details.displayName || "" }}</span>
                        </div>
                        <div class="text-muted">
                          <span>{{ user.details.email }}</span>
                        </div>
                      </b-col>
                      <b-col cols="3">
                        <p class="user-role">{{ user.role }}</p>
                      </b-col>
                    </b-row>
                    <div
                      v-if="
                        (myRole == 'manager' || myRole == 'admin') &&
                          user.role != 'admin'
                      "
                    >
                      <div class="mt-3" v-if="user.id !== my.uid">
                        <b-button
                          variant="outline-danger"
                          class="icon-left m-1"
                          v-b-modal="modalId('revokeModal', i)"
                        >
                          <font-awesome-icon icon="ban" />Remove user
                        </b-button>
                        <template
                          v-if="myRole == 'admin' && user.role != 'manager'"
                        >
                          <b-button
                            variant="outline-primary"
                            class="icon-left m-1"
                            v-b-modal="modalId('promoteModal', i)"
                          >
                            <font-awesome-icon icon="user" />Make manager
                          </b-button>
                        </template>
                        <template
                          v-else-if="
                            myRole == 'admin' && user.role == 'manager'
                          "
                        >
                          <b-button
                            variant="outline-primary"
                            class="icon-left m-1"
                            v-b-modal="modalId('demoteModal', i)"
                          >
                            <font-awesome-icon icon="user" />Revoke privileges
                          </b-button>
                        </template>
                        <b-modal
                          :id="'revokeModal' + i"
                          title="Revoke user access"
                          @ok="
                            revokeUserAccessToSubscription(
                              subscription.id,
                              user.id
                            )
                          "
                          ok-variant="danger"
                          ok-title="Yes, revoke access"
                          cancel-title="No, don't revoke access"
                        >
                          <p>
                            Are you sure you want to
                            <b>
                              revoke user access for
                              {{ user.details.displayName || "this user" }} </b
                            >? <br />The user will no longer be able to
                            view/update/map data.
                          </p>
                        </b-modal>
                        <b-modal
                          :id="'promoteModal' + i"
                          title="Make user manager"
                          @ok="
                            editUserRole(subscription.id, user.id, 'manager')
                          "
                          ok-variant="primary"
                          ok-title="Yes, make user manager"
                          cancel-title="No, cancel"
                        >
                          <p>
                            Are you sure you want to
                            <b>
                              make
                              {{ user.details.displayName || "this user" }} a
                              manager </b
                            >? <br />The user will be able to manage other users
                            in this subscription.
                          </p>
                        </b-modal>
                        <b-modal
                          :id="'demoteModal' + i"
                          title="Revoke manager privileges"
                          @ok="editUserRole(subscription.id, user.id, 'member')"
                          ok-variant="primary"
                          ok-title="Yes, revoke manager privileges"
                          cancel-title="No, cancel"
                        >
                          <p>
                            Are you sure you want to
                            <b>
                              remove
                              {{ user.details.displayName || "this user" }} as a
                              manager </b
                            >? <br />The user will still stay as a member of the
                            subscription but will not be able to manage other
                            users in this subscription.
                          </p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="text-center pt-4 pb-3 text-muted">
                <div class="d-flex justify-content-center mb-3">
                  <font-awesome-icon icon="user" size="3x" />
                </div>
                <div class="h5">You have no users assigned</div>
              </div>
              <div
                class="mt-3"
                v-if="
                  (myRole == 'manager' || myRole == 'admin') &&
                    !isFreeSubscription
                "
              >
                <p>
                  You can add
                  {{ subscription.quantity - sUsers.length || 0 }} more users.
                </p>
                <b-button
                  id="btnAddAnotherUser"
                  v-if="subscription.quantity - sUsers.length > 0"
                  v-b-modal.addUser
                  variant="primary"
                  class="icon-left m-1"
                >
                  Add another user
                  <font-awesome-icon icon="arrow-right" />
                </b-button>
                <b-modal
                  ref="addUser"
                  id="addUser"
                  title="Add User"
                  ok-title="Add user"
                  :ok-disabled="!newUser.details"
                  @ok="addUserToSubscription"
                >
                  <p>
                    Enter the user's email and click on "Fetch user details". If
                    the details match, click on "Add user" to give permission to
                    this subscription.
                  </p>
                  <b-form @submit.prevent="fetchUserDetails">
                    <b-form-group label="Email">
                      <b-form-input
                        id="txtAddNewUserField"
                        type="email"
                        v-bind:disabled="fetchingDetails"
                        autocomplete="email"
                        v-model="newUser.email"
                        placeholder="Enter new user's email"
                      />
                    </b-form-group>
                    <transition name="fade">
                      <b-button
                        id="btnFetchingUserDetails"
                        class="m-1"
                        type="submit"
                        variant="primary"
                      >
                        <span v-if="fetchingDetails">
                          Fetching user details... &nbsp;
                          <font-awesome-icon icon="sync" spin />
                        </span>
                        <span v-else>
                          Fetch user details
                          <font-awesome-icon icon="arrow-right" />
                        </span>
                      </b-button>
                    </transition>
                  </b-form>
                  <div v-if="newUser.details" class="card card-body mt-3">
                    <div>
                      <b-row>
                        <b-col cols="3" class="d-none d-md-block">
                          <img
                            alt
                            :src="
                              newUser.details
                                ? newUser.details.photoURL ||
                                  constants.profile.default_user_image
                                : constants.profile.default_user_image
                            "
                            class="avatar"
                          />
                        </b-col>
                        <b-col>
                          <div>
                            <span>{{ newUser.details.displayName || "" }}</span>
                          </div>
                          <div class="text-muted">
                            <span>{{ newUser.details.email }}</span>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getSubscriptionDetails,
  cancelSubscription,
  reactivateSubscription,
  getUserByEmail,
  getSubscriptionUsers,
  getUserByUid,
  addUserToSubscription,
  revokeUserAccessToSubscription,
  editUserRole,
  updateSubscription
} from "../modules/database";
import constants from "../modules/constants";

import { validationMixin } from "vuelidate";

import {
  integer,
  required,
  maxLength,
  helpers
} from "vuelidate/lib/validators";

const optMinValue = param =>
  helpers.withParams({ type: "optMinValue", value: param }, value => {
    const notRequired = !helpers.req(value); //true if not required
    let validParam = value >= param;
    return notRequired || validParam;
  });

import SettingsNav from "../components/SettingsNav.vue";
import { db } from "../modules/database";

export default {
  data() {
    return {
      constants: constants,
      s_id: "",
      subscription: {
        id: "",
        status: "",
        plan_unit_price: "",
        billing_period: "",
        billing_period_unit: "",
        created_at: "",
        due_invoices_count: ""
      },
      errCount: 0,
      fetchingDetails: false,
      newUser: {
        email: ""
      },
      show: true,
      loading1: false,
      loading2: false,
      myRole: "",
      sUsers: [],
      jobs: [],
      loadingJobs: false,
      isSendingEditForm: false,
      loadingError: false,
      showEditForm: false,
      updateSubscription: this.freshUpdateSubscription()
    };
  },
  mixins: [validationMixin],
  validations: {
    updateSubscription: {
      newSeats: {
        integer: integer,
        optMinValue: optMinValue(1)
      },
      name: {
        required: required,
        maxLength: maxLength(30)
      },
      c_name: {
        required: required,
        maxLength: maxLength(30)
      },
      b_address: {
        maxLength: maxLength(100)
      }
    }
  },
  computed: {
    ...mapGetters({
      my: "getUser"
    }),
    isFreeSubscription() {
      try {
        return this.subscription.plan.amount === 0;
      } catch {
        return false;
      }
    }
  },
  mounted() {
    this.getSubscription();
    this.getSubscriptionUsersFunction();
    this.setupFirebaseReading();
    this.updateSubscriptionid();
  },
  methods: {
    check_number(value, sUsers) {
      if (value > sUsers.length) {
        if (value <= 0) {
          return true;
        } else {
          return false;
        }
      } else {
        this.$root.toast("Must be greater than current user");
        return true;
      }
    },
    updateSubscriptionid() {
      this.s_id = this.$route.params.id;
    },
    check_value(event) {
      console.log(event);
    },
    toggleEditForm() {
      this.showEditForm = !this.showEditForm;
      if (!this.showEditForm) {
        this.$v.updateSubscription.$reset();
      }
    },
    freshUpdateSubscription() {
      return {
        newSeats: "",
        name: "",
        c_name: "",
        b_address: ""
      };
    },
    submitEditFormAction() {
      this.$v.updateSubscription.$touch();
      if (
        this.$v.updateSubscription.$pending ||
        this.$v.updateSubscription.$error
      )
        return;
      this.isSendingEditForm = true;
      updateSubscription(
        this.$route.params.id,
        this.updateSubscription.newSeats,
        this.updateSubscription.name,
        this.updateSubscription.c_name,
        this.updateSubscription.b_address
      )
        .then(updatedSubscription => {
          this.subscription = updatedSubscription;
          this.updateSubscription = this.freshUpdateSubscription();
          this.syncUpdatedSubscription();
          this.$root.toast(constants.info.subscription_updated);
          this.toggleEditForm();
        })
        .catch(error => {
          this.$root.toast(error);
        })
        .finally(() => {
          this.isSendingEditForm = false;
        });
    },
    modalId(start, i) {
      return start + i;
    },
    updateUserList(users) {
      this.sUsers = Object.values(users);
      for (let i = 0; i < this.sUsers.length; i++) {
        getUserByUid(this.sUsers[i].id, this.$route.params.id).then(info => {
          if (this.sUsers[i].id == this.my.uid) {
            this.myRole = this.sUsers[i].role;
          }
          this.sUsers[i].details = info;
          this.$forceUpdate();
        });
      }
    },
    fetchUserDetails() {
      if (this.newUser.email) {
        this.fetchingDetails = true;
        this.newUser.details = null;
        getUserByEmail(this.newUser.email, this.$route.params.id)
          .then(user => {
            this.newUser.details = user;
            this.fetchingDetails = false;
            this.newUser.email = "";
            this.$forceUpdate();
          })
          .catch(() => {
            this.$root.toast(constants.errors.fetch_by_email_error);
            this.fetchingDetails = false;
            this.newUser.email = "";
          });
      }
    },
    addUserToSubscription() {
      this.loading2 = true;
      addUserToSubscription(this.$route.params.id, this.newUser.details.uid)
        .then(users => {
          this.$root.toast(constants.info.user_added);
          this.updateUserList(users);
        })
        .catch(() => {
          this.$root.toast(constants.errors.add_user_error);
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    deleteSubscription(id) {
      this.loading1 = true;
      cancelSubscription(id)
        .then(cancelledSubscription => {
          this.subscription = cancelledSubscription;
          this.$root.toast(constants.info.subscription_deleted);
        })
        .catch(() => {
          this.$root.toast(constants.errors.subscription_cancel_error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    revokeUserAccessToSubscription(id, users) {
      this.loading2 = true;
      revokeUserAccessToSubscription(id, users)
        .then(users => {
          this.$root.toast(constants.info.access_revoked);
          this.updateUserList(users);
        })
        .catch(() => {
          this.$root.toast(constants.errors.remove_user_error);
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    editUserRole(id, user, role) {
      console.time("this");
      this.loading2 = true;
      editUserRole(id, user, role)
        .then(users => {
          this.$root.toast(constants.info.role_edited);
          this.updateUserList(users);
        })
        .catch(() => {
          this.$root.toast(constants.errors.privilege_error);
        })
        .finally(() => {
          this.loading2 = false;
          console.timeEnd("this");
        });
    },
    reactivateSubscription(id) {
      this.loading1 = true;
      reactivateSubscription(id)
        .then(reactivatedSubscription => {
          this.subscription = reactivatedSubscription;
          this.$root.toast(constants.info.subscription_reactivated);
        })
        .catch(() => {
          this.$root.toast(constants.errors.subscription_reactivation_error);
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    syncUpdatedSubscription() {
      if (this.subscription.metadata.friendly_name) {
        this.updateSubscription.name = this.subscription.metadata.friendly_name;
      } else {
        this.updateSubscription.name = "";
      }
      if (this.subscription.metadata.company_name) {
        this.updateSubscription.c_name = this.subscription.metadata.company_name;
      } else {
        this.updateSubscription.c_name = "";
      }
      if (this.subscription.metadata.billing_address) {
        this.updateSubscription.b_address = this.subscription.metadata.billing_address;
      } else {
        this.updateSubscription.b_address = "";
      }
      if (this.subscription.quantity) {
        this.updateSubscription.newSeats = this.subscription.quantity;
      } else {
        this.updateSubscription.newSeats = "";
      }
    },
    getSubscription() {
      this.loading1 = true;
      return getSubscriptionDetails(this.$route.params.id)
        .then(list => {
          this.subscription = list;
          this.syncUpdatedSubscription();
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    getSubscriptionUsersFunction() {
      this.loading2 = true;
      this.sUsers = [];
      getSubscriptionUsers(this.$route.params.id)
        .then(sUsers => {
          this.sUsers = Object.values(sUsers);
          for (let i = 0; i < this.sUsers.length; i++) {
            getUserByUid(this.sUsers[i].id, this.$route.params.id).then(
              info => {
                if (this.sUsers[i].id == this.my.uid) {
                  this.myRole = this.sUsers[i].role;
                }
                this.sUsers[i].details = info;
                this.$forceUpdate();
              }
            );
          }
        })
        .catch(() => {
          if (this.errCount < 3) {
            this.errCount++;
            setTimeout(() => {
              this.getSubscriptionUsersFunction();
            }, 500);
          }
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    setupFirebaseReading() {
      this.loadingJobs = true;
      this.$rtdbBind(
        "jobs",
        db.ref("jobs/" + this.$route.params.id)
        // .orderByChild("uid")
        // .equalTo(this.$route.params.id)
      )
        .catch(error => {
          console.log(error);
          this.loadingError = true;
        })
        .finally(() => {
          this.loadingJobs = false;
        });
    }
  },
  components: {
    SettingsNav
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  height: 50px;
  border-radius: 100%;
}
p.user-role {
  text-transform: capitalize;
  width: 100%;
  text-align: center;
}
</style>
